"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./DynamicTableFilters.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _map = _interopRequireDefault(require("lodash/map"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _get = _interopRequireDefault(require("lodash/get"));

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _CustomForm = _interopRequireDefault(require("../form/CustomForm"));

var _SearchFilter = _interopRequireDefault(require("./filters/SearchFilter"));

var _CustomTypeaheadInput = _interopRequireDefault(require("../form/CustomTypeaheadInput"));

var _history = _interopRequireDefault(require("../../../util/history"));

var _mobx = require("../../../util/mobx");

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var DynamicTableFilters = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicTableFilters, _React$Component);

  var _super = _createSuper(DynamicTableFilters);

  function DynamicTableFilters() {
    _classCallCheck(this, DynamicTableFilters);

    return _super.apply(this, arguments);
  }

  _createClass(DynamicTableFilters, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      // We can't be sure whether the DynamicTableFilters or the DynamicTable will be
      // mounted first. As a result, we bind in both places.
      this.props.model.bindDispatcher(this.props.dispatcher);

      if (this.props.model.enableHistory) {
        this.props.model.parseUrlSearchQuery(window && window.location ? window.location.search : "");

        _history.default.addPopStateListener(function (e) {
          _this.props.model.parseUrlSearchQuery(window && window.location ? window.location.search : "");
        });
      }
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(filterModel, e) {
      this.props.model.updateFilter(filterModel.key, e.target.value, this.props.dispatcher);
    }
  }, {
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(filterModel, e) {
      this.props.model.updateFilter(filterModel.key, e.target.checked ? filterModel.checkboxValue : "", this.props.dispatcher);
    }
  }, {
    key: "handleTypeaheadFilterChange",
    value: function handleTypeaheadFilterChange(filterModel, option) {
      var value = (0, _get.default)(option, "value", null);
      this.props.model.updateFilter(filterModel.key, value, this.props.dispatcher);
    }
  }, {
    key: "handleSearchSubmit",
    value: function handleSearchSubmit(filterModel, e) {
      e.preventDefault();
      this.props.model.updateFilter(filterModel.key, filterModel.searchValue, this.props.dispatcher);
    }
  }, {
    key: "handleSearchClear",
    value: function handleSearchClear(filterModel, e) {
      this.props.model.updateFilter(filterModel.key, "", this.props.dispatcher);
    }
  }, {
    key: "handleTypeaheadBlur",
    value: function handleTypeaheadBlur(filterModel, e) {
      if ((0, _isEmpty.default)(e.target.value)) {
        this.handleTypeaheadFilterChange(filterModel, "");
      }
    }
  }, {
    key: "renderTypeaheadFilter",
    value: function renderTypeaheadFilter(filterModel, index, dispatcher) {
      var _this2 = this;

      var filterClasses = {
        "typeahead-filter": true
      };

      if (filterModel.className) {
        filterClasses[filterModel.className] = true;
      }

      return /*#__PURE__*/_react.default.createElement(_CustomForm.default, {
        key: index,
        className: (0, _classnames.default)(filterClasses),
        form: filterModel.typeaheadForm
      }, /*#__PURE__*/_react.default.createElement(_CustomTypeaheadInput.default, _extends({
        id: "typeahead-filter-".concat(index),
        fieldName: "typeaheadValue",
        dispatcher: dispatcher,
        onOptionSelected: function onOptionSelected(option) {
          return _this2.handleTypeaheadFilterChange(filterModel, option);
        },
        onBlur: this.handleTypeaheadBlur.bind(this, filterModel),
        maxVisible: 5,
        endpoint: filterModel.endpoint,
        placeholder: filterModel.placeholder,
        disabled: this.props.disableUntilLoaded && !this.props.model.isLoaded
      }, filterModel.definition.typeaheadProps)));
    }
  }, {
    key: "renderSelectFilter",
    value: function renderSelectFilter(filterModel, index) {
      var filterClasses = {
        "custom-select": true,
        "has-value": !(0, _isEmpty.default)(filterModel.value),
        active: false // TODO implement

      };
      filterClasses[(0, _toLower.default)(filterModel.columnName)] = true;

      if (filterModel.className) {
        filterClasses[filterModel.className] = true;
      }

      var placeholderOption = filterModel.placeholder && !(0, _isEmpty.default)(filterModel.placeholder) ? /*#__PURE__*/_react.default.createElement("option", {
        key: filterModel.placeholder,
        value: "",
        default: true
      }, filterModel.placeholder) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: (0, _classnames.default)(filterClasses)
      }, /*#__PURE__*/_react.default.createElement("select", {
        key: index,
        value: filterModel.value,
        onChange: this.handleFilterChange.bind(this, filterModel),
        disabled: this.props.disableUntilLoaded && !this.props.model.isLoaded
      }, placeholderOption, (0, _map.default)(filterModel.definition.options, function (option, optionIndex) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: optionIndex,
          value: (0, _isFunction.default)(option.value) ? option.value() : option.value
        }, (0, _isFunction.default)(option.label) ? option.label() : option.label);
      })));
    }
  }, {
    key: "renderCheckboxFilter",
    value: function renderCheckboxFilter(filterModel, index) {
      var filterClasses = {
        "custom-checkbox-container": true,
        checked: !(0, _isEmpty.default)(filterModel.value)
      };
      filterClasses[(0, _toLower.default)(filterModel.columnName)] = true;

      if (filterModel.className) {
        filterClasses[filterModel.className] = true;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: (0, _classnames.default)(filterClasses)
      }, /*#__PURE__*/_react.default.createElement("input", {
        id: filterModel.key,
        className: "custom-checkbox",
        type: "checkbox",
        name: filterModel.key,
        value: filterModel.checkboxValue,
        checked: !(0, _isEmpty.default)(filterModel.value),
        onChange: this.handleCheckboxChange.bind(this, filterModel),
        disabled: this.props.disableUntilLoaded && !this.props.model.isLoaded
      }), /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: filterModel.key
      }, filterModel.label));
    }
  }, {
    key: "renderSortFilter",
    value: function renderSortFilter(filterModel, index) {
      var filterClasses = {
        "sort-select": true
      };

      if (filterModel.className) {
        filterClasses[filterModel.className] = true;
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        key: index
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "sort-by"
      }, "Sort by:"), /*#__PURE__*/_react.default.createElement("select", {
        value: filterModel.value,
        className: (0, _classnames.default)(filterClasses),
        onChange: this.handleSortChange.bind(this, filterModel),
        disabled: this.props.disableUntilLoaded && !this.props.model.isLoaded
      }, (0, _map.default)(filterModel.definition.options, function (option, optionIndex) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: optionIndex,
          value: optionIndex
        }, (0, _isFunction.default)(option.label) ? option.label() : option.label);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var filters = _mobx.observableMap.values(this.props.model.filters);

      var filterControlsClasses = (0, _classnames.default)("filter-controls", this.props.className);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: filterControlsClasses
      }, (0, _map.default)(filters, function (filter, index) {
        if (filter.type === "search") {
          return /*#__PURE__*/_react.default.createElement(_SearchFilter.default, {
            key: "search-".concat(index),
            filterModel: filter,
            tableModel: _this3.props.model,
            disableUntilTableModelLoaded: _this3.props.disableUntilLoaded
          });
        } else if (filter.type === "select") {
          return _this3.renderSelectFilter(filter, index);
        } else if (filter.type === "sort") {
          // not yet fully supported in mobx
          return _this3.renderSortFilter(filter, index);
        } else if (filter.type === "typeahead") {
          return _this3.renderTypeaheadFilter(filter, index, _this3.props.dispatcher);
        } else if (filter.type === "checkbox") {
          return _this3.renderCheckboxFilter(filter, index);
        }

        return null;
      }));
    }
  }]);

  return DynamicTableFilters;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  model: _propTypes.default.object.isRequired,
  dispatcher: _propTypes.default.object.isRequired,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  disableUntilLoaded: _propTypes.default.bool
}), _defineProperty(_class3, "defaultProps", {
  disableUntilLoaded: true
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handleTypeaheadFilterChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleTypeaheadFilterChange"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(DynamicTableFilters);

exports.default = _default;